import React, { useEffect, useMemo, useState } from "react";
import { getUser } from "../../../services/utils";
import { ContactSubmission } from "../ContactSubmissions.types";
import { api } from "../../../services/api";
import { useAdminUsers } from "../../manageAdmin/context/AdminUsersContext";
import { AdminPermission } from "../../manageAdmin/AdminUserList.types";

export const ContactSubmissionsContext = React.createContext<{
  contactSubmissions: Array<ContactSubmission>;
  refreshSubmissions: () => {}
}>({
  contactSubmissions: [],
  refreshSubmissions: () => ({}),
});

export function ContactSubmissionsProvider({ children }) {
  const { myPermissions } = useAdminUsers();
  const user = getUser();
  const [contactSubmissions, setContactSubmissions] = useState<Array<ContactSubmission>>([]);

  const fetchSubmissions = useMemo(
    () => async () => {
      if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_FEEDBACK)) {
        const result = await api.getContactSubmissions();
        setContactSubmissions(result);
      }
    },
    [myPermissions]
  );

  useEffect(() => {
    if (user?.id) {
      fetchSubmissions();
    }
  }, [user?.id, myPermissions]);

  const values = useMemo(
    () => ({
      contactSubmissions: contactSubmissions,
      refreshSubmissions: fetchSubmissions,
    }),
    [contactSubmissions, fetchSubmissions]
  );

  return <ContactSubmissionsContext.Provider value={values}>{children}</ContactSubmissionsContext.Provider>;
}

export function useContactSubmissions() {
  const context = React.useContext<{
    contactSubmissions: Array<ContactSubmission>;
    refreshSubmissions: () => {}
  }>(ContactSubmissionsContext);
  if (context === undefined) {
    throw new Error("useContactSubmissions must be used within a ContactSubmissionsProvider");
  }
  return context;
}
